var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.70154 0.296043C2.31526 -0.0986813 1.68898 -0.0986808 1.3027 0.296043L1.2858 0.313313C0.899524 0.708037 0.899524 1.34801 1.2858 1.74273L8.59456 9.21129L1.69959 16.257C1.31331 16.6517 1.31331 17.2917 1.69959 17.6864L1.71649 17.7037C2.10277 18.0984 2.72905 18.0984 3.11533 17.7037L10.0103 10.658L16.8758 17.6736C17.2621 18.0683 17.8884 18.0683 18.2747 17.6736L18.2916 17.6564C18.6779 17.2616 18.6779 16.6217 18.2916 16.2269L11.426 9.21129L18.7054 1.77282C19.0916 1.37809 19.0916 0.73812 18.7054 0.343396L18.6885 0.326126C18.3022 -0.0685977 17.6759 -0.0685983 17.2896 0.326126L10.0103 7.7646L2.70154 0.296043Z","fill":"white"}));
}

Cross.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
